import script from "./TokenWeightInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenWeightInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenWeightInput.vue?vue&type=style&index=0&id=ddb4432e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddb4432e"]])

export default __exports__